export default __webpack_public_path__ + "static/3-72b680bf4c08e31b0ded24503f9ea2e5.jpeg";